import type { AuditedEntityDto } from '@abp/ng.core';

export interface NotificationDto extends AuditedEntityDto<string> {
  title?: string;
  message?: string;
  emitterId?: string;
  isRead: boolean;
}
